export const listAuditLogService = (fetch) => async (filters) => {
  try {
    const cleanFilters = Object.fromEntries(
      Object.entries(filters || {}).filter(
        ([, v]) => v !== undefined && v !== null && v !== ""
      )
    );
    const searchParams = new URLSearchParams(cleanFilters).toString();
    const response = await fetch({
      url: `/api/v1/auditoria?${searchParams}`,
    });
    return response;
  } catch (error) {
    console.error("Error fetching audit logs:", error);
    throw new Error(error.response?.data?.message || error.message);
  }
};
